import verified from "@/assets/verified.svg";
import { openUrl } from "@/bridge/openUrl";


export function AgreementsSection() {
    const agreements = [
      { id: 1, name: 'Terms of Use', link: 'https://skillscratch.com/legal/terms', checked: true },
      { id: 2, name: 'Privacy Policy', link: 'https://skillscratch.com/legal/privacy', checked: true },
      { id: 3, name: 'Prelicensing Agreement', link: 'https://skillscratch.com/legal/licensing', checked: true },
    ];
  
    return (
      <div className='mb-8'>
        <h1 className="text-2xl font-bold text-blue-dark mb-1">My Agreements</h1>
        <p className="text-blue-dark mb-4 text-sm">
            At signup, you agreed to the following, including future allowed modifications:
        </p>
        
        <div className="space-y-2 mb-6">
          {agreements.map((agreement) => (
            <div key={agreement.id} className="flex items-center">
            <span className="mr-2">
                <img src={verified} alt="Verified" className="h-4 w-4" />
            </span>
              <a 
                // biome-ignore lint/a11y/useValidAnchor: <explanation>
                onClick={() => openUrl(agreement.link)}
                className="text-slate underline text-sm"
              >
                {agreement.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  }